var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../styled';
import { Image } from '../image';
import { composeClasses } from '../styles/classes';
import { getLogoUtilityClass, logoComponentName } from './logo-classes';
import clsx from '../utils/clsx';
import { useThemeProps } from '../theme/use-theme-props';
export var Root = styled('div', {
    name: logoComponentName,
    slot: 'Root',
})(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return __assign(__assign({ color: {
            dark: theme.tokens.color_fg_bold,
            white: theme.tokens.color_fg_inverse_static,
            light: theme.tokens.color_fg_default,
            default: theme.tokens.color_fg_brand_primary,
            decorative: theme.tokens.color_fg_decorative,
        }[ownerState.color || 'default'], display: 'inline-block', width: 'auto', height: theme.typography.pxToRem(36) }, (ownerState.size === 'xsmall' && {
        height: theme.typography.pxToRem(19),
    })), (ownerState.size === 'small' && {
        height: theme.typography.pxToRem(30),
    }));
});
var StyledSvg = styled('svg', {
    name: logoComponentName,
    slot: 'Svg',
})(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return __assign(__assign({ display: 'block', width: 'auto', height: theme.typography.pxToRem(36) }, (ownerState.size === 'xsmall' && {
        height: theme.typography.pxToRem(19),
    })), (ownerState.size === 'small' && {
        height: theme.typography.pxToRem(30),
    }));
});
var LogoImage = styled(Image)(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return (__assign(__assign({ display: 'block', width: 'auto', height: theme.typography.pxToRem(36) }, (ownerState.size === 'xsmall' && {
        height: theme.typography.pxToRem(19),
    })), (ownerState.size === 'small' && {
        height: theme.typography.pxToRem(30),
    })));
});
var useUtilityClasses = function (_a) {
    var classes = _a.classes;
    var slots = {
        root: ['root'],
        svg: ['svg'],
    };
    return composeClasses(slots, getLogoUtilityClass, classes);
};
export var Logo = React.forwardRef(function (inProps, ref) {
    var props = useThemeProps({
        props: inProps,
        name: logoComponentName,
    });
    var classes = useUtilityClasses(props);
    var size = props.size, color = props.color, className = props.className, iconSrc = props.iconSrc, rootProps = __rest(props, ["size", "color", "className", "iconSrc"]);
    return (React.createElement(Root, __assign({ ref: ref, className: clsx(classes.root, className), ownerState: { size: size, color: color } }, rootProps), iconSrc ? (React.createElement(LogoImage, { src: iconSrc, ownerState: { size: size }, fit: "contain", alt: "Logo" })) : (React.createElement(StyledSvg, { fill: "currentColor", viewBox: "0 0 53 64", className: classes.svg, ownerState: { size: size } },
        React.createElement("path", { d: "M3.372 27.782c10.475-1.728 18.686-10.4 20.407-20.892l.577-5.043c.143-.802-.4-1.918-1.412-1.838C15.03.628 7.56 3.243 3.406 4.943A5.488 5.488 0 000 10.027v16.451c0 .973.874 1.717 1.834 1.563l1.538-.252v-.006zM28.831 6.89c1.726 10.492 9.938 19.164 20.407 20.893l1.537.252c.96.16 1.835-.584 1.835-1.563v-16.45a5.488 5.488 0 00-3.406-5.084C45.044 3.232 37.58.622 29.666.004c-1.018-.08-1.538 1.048-1.418 1.837l.577 5.043.006.006zM49.23 32.39C34.915 35.219 28.27 44.75 28.27 62.79c0 .905.897 1.535 1.651 1.031 6.584-4.447 21.07-16.056 22.562-30.577.057-1.826-2.223-.968-3.252-.853zM3.377 32.39c14.315 2.828 20.961 12.359 20.961 30.4 0 .905-.897 1.535-1.651 1.031C16.103 59.374 1.617 47.765.125 33.244c-.057-1.826 2.223-.968 3.252-.853z" })))));
});
